// @ts-nocheck
import { getCookie } from "@insite/client-framework/Common/Cookies";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    errorText = "errorText",
}

interface Props extends WidgetProps {
    fields: {
        [fields.errorText]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const parsedQuery = parseQueryString<{ error?: string; externalError?: string }>(getLocation(state).search);
    return {
        internalErrorMessage: parsedQuery.error,
        externalErrorMessage: parsedQuery.externalError,
        homeUrl: getPageLinkByPageType(state, "HomePage")?.url,
        externalSignInUrl: getCookie("ExternalSignInUrl"),
    };
};

type OwnProps = Props & ReturnType<typeof mapStateToProps>;

export interface CustomSsoErrorStyles {
    errorTitle?: TypographyPresentationProps;
    errorMessage?: TypographyPresentationProps;
}

export const customSsoErrorStyles: CustomSsoErrorStyles = {
    errorTitle: {
        variant: "h4",
        forwardAs: "p",
    },
    errorMessage: {
        css: css`
            color: ${getColor("danger")};
        `,
    },
};

const styles = customSsoErrorStyles;

const CustomSsoError = ({
    fields,
    internalErrorMessage,
    externalErrorMessage,
    homeUrl,
    externalSignInUrl,
}: OwnProps) => {
    const { isInShell } = useShellContext();

    useEffect(() => {
        if (!isInShell && !internalErrorMessage && !externalErrorMessage) {
            window.location.href = homeUrl || "/";
        }
    }, []);

    const redirectToExternalSignInUrl = () => {
        if (externalSignInUrl) {
            window.location.href = externalSignInUrl;
        }
    };

    if (!internalErrorMessage && !externalErrorMessage) {
        return null;
    }

    return (
        <>
            {fields.errorText && <Typography {...styles.errorTitle}>{fields.errorText}</Typography>}
            <Typography {...styles.errorTitle}>
                {translate("Error")}:&nbsp;
                {internalErrorMessage && (
                    <Typography {...styles.errorMessage}>{translate(`${internalErrorMessage}`)}</Typography>
                )}
                {externalErrorMessage && <Typography {...styles.errorMessage}>{externalErrorMessage}</Typography>}
            </Typography>
            {externalSignInUrl && (
                <Button onClick={redirectToExternalSignInUrl}>{translate("Return to procurement system")}</Button>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CustomSsoError),
    definition: {
        group: "Sign In",
        allowedContexts: ["CustomSsoPage"],
        displayName: "Custom Sso Error",
        fieldDefinitions: [
            {
                name: fields.errorText,
                displayName: "Error Text",
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: false,
            },
        ],
    },
};

export default widgetModule;
